import { render, staticRenderFns } from "./FormatListChecks.vue?vue&type=template&id=e2837bd4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatListChecks.vue
// module id = 1097
// module chunks = 0